import { Box, Tabs, Tab } from "@mui/material";
import dayjs from "dayjs";

interface MonthTabsProps {
  rangeStart: string;
  rangeEnd: string;
  selectedTab: number;
  onTabChange: (value: number) => void;
}

const parseCompetence = (value: string) => {
  const [month, year] = value.split("/");
  return { month, year: parseInt(year) };
};

const getMonthRange = (rangeStart: string, rangeEnd: string) => {
  const start = parseCompetence(rangeStart);
  const end = parseCompetence(rangeEnd);
  const startDate = dayjs(`${start.year}-${start.month}-01`);
  const endDate = dayjs(`${end.year}-${end.month}-01`);
  const months = [];
  let current = startDate;
  while (current.isBefore(endDate) || current.isSame(endDate, "month")) {
    months.push(current.format("MM/YYYY"));
    current = current.add(1, "month");
  }
  return months;
};

const MonthTabs = ({
  rangeStart,
  rangeEnd,
  selectedTab,
  onTabChange,
}: MonthTabsProps) => {
  const monthTabs = getMonthRange(rangeStart, rangeEnd);

  if (monthTabs.length === 0) return null;

  return (
    <Box
      sx={{
        borderRadius: 1,
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Tabs
        value={selectedTab}
        onChange={(e, newValue) => onTabChange(newValue)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          "& .MuiTabs-scrollButtons": {
            color: "primary.main",
            "&.Mui-disabled": {
              opacity: 0.3,
            },
          },
          "& .MuiTabs-scroller": {
            "&::-webkit-scrollbar": {
              height: 4,
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "rgba(0,0,0,0.1)",
              borderRadius: 2,
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "primary.main",
              borderRadius: 2,
              "&:hover": {
                backgroundColor: "primary.dark",
              },
            },
          },
        }}
      >
        {monthTabs.map((month, index) => (
          <Tab key={index} label={month} sx={{ minHeight: 50 }} />
        ))}
      </Tabs>
    </Box>
  );
};

export default MonthTabs;
